






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ContentTemplate, ContentTemplateSizesDtoOut } from "@/services/contentTemplates/types";
import { Channel } from "@/services/channels/types";
import { getChannelById } from "@/services/channels/channelsService";
import { getContentTemplatesBySize } from "@/services/contentTemplates/contentTemplateService";

@Component({})
export default class ChannelAddCustomPostTemplateModal extends Vue {
    @Prop() channelId!: string;
    @Prop({ default: undefined }) propSize!: any;
    @Prop() isEditor!: boolean;
    channel = {} as Channel;
    contentTemplates = [] as ContentTemplate[];
    navigateToCreateItem = false;
    sizes = [] as string[];
    selectedSize = "";
    cachedSizes = [] as string[];
    loading = true;
    postType = "";

    // computed
    get filteredData() : ContentTemplate[] {
        const dimensions = this.selectedSize.split("x");
        return this.contentTemplates
            .filter(ct => ct.width === +dimensions[0] &&
                ct.height === +dimensions[1] &&
                ct.type.toLowerCase() === this.postType.toLowerCase()
            );
    }

    calculateStyle(ct: any) {
        const scale = Math.min(195 / ct.width, 120 / ct.height);
        return {
            width: ct.width + "px",
            height: ct.height + "px",
            transform: `scale(${scale}) translate(-50%, -50%)`
        };
    }

    @Watch("selectedSize") w() {
        if (this.selectedSize === "") return;
        const dimensions = this.selectedSize.split("x");
        if (!this.cachedSizes.includes(this.selectedSize)) {
            this.loading = true;
            getContentTemplatesBySize(+dimensions[0], +dimensions[1], false, 0).then(response => {
                this.contentTemplates.push(...response);
                this.cachedSizes.push(this.selectedSize);
                this.loading = false;
            });
        }
    }

    // methods
    open(navigationState: boolean, sizes: ContentTemplateSizesDtoOut[], postType = "html") {
        this.navigateToCreateItem = navigationState;
        this.postType = postType;

        this.sizes = this.sizes.concat(sizes.map(ct => {
            return `${ct.width}x${ct.height}`;
        }));

        this.$nextTick(async () => {
            if (!this.propSize) {
                const channel: Channel = await getChannelById(this.channelId);
                this.selectedSize = `${channel.width}x${channel.height}`;
            } else this.selectedSize = `${this.propSize.width}x${this.propSize.height}`;

            this.sizes.unshift(this.selectedSize);
            this.sizes = [...new Set(this.sizes)];
            this.$bvModal.show("modal-addCustomPostTemplate");
        });
    }

    selectTemplate(templateId: string) {
        if (this.navigateToCreateItem) {
            if (this.isEditor) {
                this.$router.push({
                    name: "editorCreatePost",
                    params: {
                        channelId: this.channelId,
                        postType: this.postType,
                        contentTemplateId: templateId
                    }
                });
            } else {
                this.$router.push({
                    name: "createPost",
                    params: {
                        channelId: this.channelId,
                        postType: this.postType,
                        contentTemplateId: templateId
                    }
                });
            }
        }
        this.$emit("contentTemplateSelected", templateId);
        this.$bvModal.hide("modal-addCustomPostTemplate");
    }

    blankPost() {
        this.$router.push({
            name: "createPost",
            params: {
                channelId: this.channelId,
                postType: this.postType
            }
        });
    }

    resetData() {
        this.sizes = [] as string[];
        this.selectedSize = "";
        this.contentTemplates = [] as ContentTemplate[];
        this.cachedSizes = [];
    }
}
